import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/progress/index.js
// module id = 327
// module chunks = 0